function headerAnimate(el) {
  jQuery(document).ready(headerAnimateFn);
  jQuery(window).load(headerAnimateFn);
  jQuery(window).scroll(headerAnimateFn);
  jQuery(window).resize(headerAnimateFn);

  function headerAnimateFn() {
    var w = jQuery(window).width();
    var h = jQuery(el).outerHeight();
    var t = jQuery(window).scrollTop();
    
    $('body').addClass('nopadding');
    

    if (t > 0) {
      jQuery('#static-header .header.sticky-header').removeClass('higher-than-slideshow');
      jQuery('#static-header .header.sticky-header').addClass('lower-than-slideshow');
    } else {
      jQuery('#static-header .header.sticky-header').addClass('higher-than-slideshow');
      jQuery('#static-header .header.sticky-header').removeClass('lower-than-slideshow');
    }
  }
}

function pageRecykoProductTable(el_name) {
  jQuery(window).resize(table);
  jQuery(window).on('load', table);
  table()
  setTimeout(table, 500);
  function table() {
    jQuery('tr', el_name).each(function (i) {
      var td = $('td:first-child', this),
        th = $('th', this);
      td.removeAttr('style');
      th.removeAttr('style');

      var h = $('th:last-child', this).outerHeight();
      th.css({
        height: h,
      });
      $('td:first-child', this).css({
        position: 'absolute',
        height: h,
      });
      setTimeout(function() {
        td.css({
          display: 'flex',
        });
      }, 300)
    });
  }
}

function pageRecykoProductTab(el_name) {
  var container_name = el_name+'-tab-container',
    nav_name = el_name+'-tab-nav',
    tabs_name = el_name+'-tabs',
    tab_name = el_name+'-tab',
    container = jQuery(container_name),
    nav = jQuery(nav_name),
    nav_li = jQuery('li', nav);
    nav_a = jQuery('a', nav);
    tabs = jQuery(tabs_name),
    tab = jQuery(tab_name);

  var idx = 0, active = false;
  nav_a.each(function (i) {
    if ($(this).hasClass('active')) {
      idx = i;
      active = true;
    }
  });
  nav_a.eq(idx).addClass('active');
  tab.eq(idx).addClass('active');

  nav_a.on('click', function (e) {
    var li = $(this).parent();
    var idx = nav_li.index(li);
    
    nav_a.removeClass('active');
    tab.removeClass('active');
    
    nav_a.eq(idx).addClass('active');
    tab.eq(idx).addClass('active');

    $('html, body').stop().animate( {
      'scrollTop': container.offset().top
    }, 900)
  });
}